module.exports = __webpack_public_path__ + "static/media/NineUmbrella.6ce59dff.png";